import { lazy, Suspense } from 'react';

const ChatWidget = lazy(async () => import('chat_widget/AssistChatWidget'));

export const ChatWidgetMFWrapper = (props: ChatWidgetProps) => {
  return (
    <Suspense fallback={<></>}>
      <ChatWidget {...props} />
    </Suspense>
  );
};
